export default __webpack_public_path__ + "static/media/wufoo.de2a110a.svg";